import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {  FilterItem, FilterType, InputType, PagingOptions, TagsInputOptions, TextBoxOptions } from 'bnsights-control-library';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { PermissionSetUsersIDRequestModel } from '../../shared/models/PermissionsModels/PermissionSetUsersIDRequestModel';
import { DataSecretService } from '../../shared/Services/data.service';
import { PermissionSetService } from '../../shared/Services/PermissionSetService.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-permission-set-info',
  templateUrl: './permission-set-info.component.html'
})
export class PermissionSetInfoComponent implements OnInit {

  ApiUrl = "/api/admin/PermissionSets/"
  SubheaderTitle = "";
  BreadcrumbTitle = this.utilityService.getResourceValue('PermissionSets');
  Url:string="/Admin/Roles/PermissionSets"
  ShowToolbar = true;
  ShowbreadCrumb = true;
  searchTextBox: TextBoxOptions;
  PermissionSetIdTextBox: TextBoxOptions;
  filterForm = new FormGroup({});
  UserPermissionSetForm = new FormGroup({});
  showFilter: boolean = false;
  UserPermissionSetPagingResult: any[] = [];
  UserPermissionSetPaging: PagingOptions;
  TextInputFilter: FilterItem;
  PermissionSetIdTextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  PermissionSetId: string = ""
  PageName:string=""
  @ViewChild('UserPermissionSetPagingViewElement', { static: false }) input: ElementRef;
  // Decorator wires up blockUI instance
  ShowPageContent: boolean = false;

  //Add Model Controls
  AddUsersToPermissionSetForm = new FormGroup({});
  UserAutoComplete: TagsInputOptions;
  @ViewChild('CloseAddUsersToPermissionSet', { static: false }) CloseAddUsersToPermissionSet: ElementRef;
  language:string=""

  //delete  Model Controls
  deleteUserId: number;
  @ViewChild('CloseDeleteUserFromPermissionSetModal', { static: false }) CloseDeleteUserFromPermissionSetModal: ElementRef;

  constructor(private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private activatedRoute: ActivatedRoute, private dataServices: DataSecretService, private authService: AuthService, private PermissionSetService: PermissionSetService, private modalService: NgbModal) {

  }
  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    var PermissionSetNameObject = localStorage.getItem('PermissionSetName');
    let PageName = JSON.parse(PermissionSetNameObject);
     //console.log(PageName);
    this.SubheaderTitle = this.language == 'en' ? PageName.English : PageName.Arabic;    
    PageInfoService.PageTitle=this.SubheaderTitle
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false},
       {title: this.utilityService.getResourceValue("PermissionSets"), path: '/Admin/Roles/PermissionSets', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];

    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.activatedRoute.params.subscribe(params => {
      this.PermissionSetId = params['id'];
      this.LoadUserList();
    });
  }

 
  ReinitializeUserPermissionSetPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateUserPermissionSetPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setUserPermissionSetListResult(result) {
    this.UserPermissionSetPagingResult = result;
    this.ShowPageContent = true;
  }

  resetFilters() {
    this.UserPermissionSetForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  LoadUserList() {
    // TextBox inti
    this.utilityService.startBlockUI()
    this.searchTextBox = new TextBoxOptions();
    this.searchTextBox.Name = "searchTextBox"
    this.searchTextBox.HideLabel = true
    this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByNameOrEmail");

    this.PermissionSetIdTextBox = new TextBoxOptions();
    this.PermissionSetIdTextBox.Name = "PermissionSetIdTextBox"
    this.PermissionSetIdTextBox.HideLabel = true
    this.PermissionSetIdTextBox.Type = InputType.Text
    this.PermissionSetIdTextBox.Value = this.PermissionSetId;
    this.PermissionSetIdTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName");

    this.TextInputFilter = new FilterItem();
    this.TextInputFilter.FormControlName = "searchTextBox"
    this.TextInputFilter.ActionParameterName = "searchText"
    this.TextInputFilter.IsFormControl = true
    this.TextInputFilter.FilterType = FilterType.TextBox

    this.PermissionSetIdTextInputFilter = new FilterItem();
    this.PermissionSetIdTextInputFilter.FormControlName = "PermissionSetIdTextBox"
    this.PermissionSetIdTextInputFilter.ActionParameterName = "permissionSetId"
    this.PermissionSetIdTextInputFilter.IsFormControl = true
    this.PermissionSetIdTextInputFilter.FilterType = FilterType.TextBox

    this.UserPermissionSetPaging = new PagingOptions();
    this.UserPermissionSetPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetUsersByFilter';
    this.UserPermissionSetPaging.OnKeyPressFiltersControlNames = ["searchTextBox", "PermissionSetIdTextBox"]
    this.UserPermissionSetPaging.Filters = [this.TextInputFilter, this.PermissionSetIdTextInputFilter]
    this.UserPermissionSetPaging.ValidationToken = this.authService.authorizationHeaderValue();
    setTimeout(() => {
      this.IsFilterLoaded = true;
      this.utilityService.stopBlockUI();
    }, 10);
  }



  showAddUserToPermissionSetModal(AddUserToPermissionSetModal) {
    this.utilityService.startBlockUI();
    this.AddUsersToPermissionSetForm = new FormGroup({});
    this.UserAutoComplete = new TagsInputOptions();
    this.UserAutoComplete.Name = "UserAutoComplete";
    this.UserAutoComplete.LabelKey = "Users";
    this.UserAutoComplete.IsRequired = true;
    this.UserAutoComplete.Value = null;
    this.UserAutoComplete.ActionURL = this.environmentService.getApiUrl() + this.ApiUrl + "AutoCompleteUserList"
    this.UserAutoComplete.ValidationToken = this.authService.authorizationHeaderValue()
    this.modalService.open(AddUserToPermissionSetModal);
    this.utilityService.stopBlockUI();
  }

  addUserToPermissionSet() {
    if (this.AddUsersToPermissionSetForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddUsersToPermissionSetForm.value;
      let AddModel:PermissionSetUsersIDRequestModel= new PermissionSetUsersIDRequestModel() ;
      for (let index = 0; index < ResultModel.UserAutoComplete.length; index++) {
        const key = ResultModel.UserAutoComplete[index].key;
        AddModel.UsersIDs.push(Number(key))
        
      }
      AddModel.PermissionSetId=Number(this.PermissionSetId);
      this.PermissionSetService.AddUsersToPermissionSet( AddModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
        
      })
    }
  }


  showDeleteUserFromPermissionSetModal(user: any, deleteUserPermissionSetModal) {
    this.utilityService.startBlockUI();
    this.deleteUserId = user.id
    this.modalService.open(deleteUserPermissionSetModal);
    this.utilityService.stopBlockUI();

  }

  deleteUserFromPermissionSet() {
    this.PermissionSetService.DeleteUserFromPermissionSet( this.deleteUserId.toString(), this.PermissionSetId).subscribe((result) => {
      var data = result as any;
      if (!data.val) {
        console.log("notified error");
        this.utilityService.notifyErrorMessage(this.utilityService.getResourceValue("CannotDeleteLastUserPermissionSet"));
      }
      else {
        this.utilityService.notifySuccessMessage()
      }
      this.deleteUserId = 0;
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
      
    })
  }



}
